/**
 * Do not edit directly, this file was auto-generated.
 */

module.exports = {
  "black-0a": "#00000000",
  "black-12a": "#0000001f",
  "black-18a": "#0000002e",
  "black-24a": "#0000003d",
  "black-4a": "#0000000a",
  "black-40a": "#00000066",
  "black-50a": "#00000080",
  "black-6a": "#0000000f",
  "black-60a": "#00000099",
  "black-70a": "#000000b2",
  "black-8a": "#00000014",
  "black-80a": "#000000cc",
  "black-90a": "#000000e5",
  "purple-500-20a": "#ba62fd33",
  "purple-500-90a": "#ba62fde5",
  "purple-600-10a": "#7a12d41a",
  "purple-tint": "#9b37f2",
  "white-0a": "#ffffff00",
  "white-12a": "#ffffff1f",
  "white-18a": "#ffffff2e",
  "white-24a": "#ffffff3d",
  "white-4a": "#ffffff0a",
  "white-40a": "#ffffff66",
  "white-50a": "#ffffff80",
  "white-6a": "#ffffff0f",
  "white-60a": "#ffffff99",
  "white-70a": "#ffffffb2",
  "white-8a": "#ffffff14",
  "white-80a": "#ffffffcc",
  "white-90a": "#ffffffe5",
  "aqua-50": "#eaf7ff",
  "aqua-100": "#dff4ff",
  "aqua-200": "#caecff",
  "aqua-300": "#a0ddff",
  "aqua-400": "#76ceff",
  "aqua-500": "#2cb3ff",
  "aqua-600": "#1b9ce6",
  "aqua-700": "#1785c3",
  "aqua-800": "#126596",
  "aqua-900": "#0c4668",
  "blue-50": "#ebf5ff",
  "blue-100": "#e0f0ff",
  "blue-200": "#cce6ff",
  "blue-300": "#a3d3ff",
  "blue-400": "#7abfff",
  "blue-500": "#329dff",
  "blue-600": "#005cff",
  "blue-700": "#1c3bd4",
  "blue-800": "#1832b4",
  "blue-900": "#12268a",
  "cool-grey-100": "#f9f9f9",
  "cool-grey-150": "#f3f4f6",
  "cool-grey-200": "#f3f4f6",
  "cool-grey-250": "#dfe1e5",
  "cool-grey-300": "#ced1d7",
  "cool-grey-350": "#b3b8c1",
  "cool-grey-400": "#979ca5",
  "cool-grey-450": "#71767f",
  "cool-grey-500": "#595e67",
  "cool-grey-550": "#41464f",
  "cool-grey-600": "#292d38",
  "cool-grey-650": "#181d26",
  "cool-grey-700": "#0f131a",
  "green-50": "#e8f9f1",
  "green-100": "#dcf6ea",
  "green-200": "#c5efdd",
  "green-300": "#97e3c1",
  "green-400": "#69d7a6",
  "green-500": "#18c176",
  "green-600": "#159f65",
  "green-700": "#128756",
  "green-800": "#0e6742",
  "green-900": "#09482d",
  "grey-100": "#f9f9f9",
  "grey-150": "#f3f4f6",
  "grey-200": "#ebedef",
  "grey-250": "#dfe1e5",
  "grey-300": "#ced1d7",
  "grey-350": "#b3b8c1",
  "grey-400": "#979ca5",
  "grey-450": "#71767f",
  "grey-500": "#595e67",
  "grey-550": "#41464f",
  "grey-600": "#292d38",
  "grey-650": "#181d26",
  "grey-700": "#0f131a",
  black: "#000000",
  white: "#ffffff",
  "orange-50": "#fff4e9",
  "orange-100": "#ffefdd",
  "orange-200": "#ffe4c7",
  "orange-300": "#ffce9a",
  "orange-400": "#ffb96d",
  "orange-500": "#ff931f",
  "orange-600": "#ed6325",
  "orange-700": "#c9541f",
  "orange-800": "#9a4018",
  "orange-900": "#6b2d11",
  "pink-50": "#feeaf3",
  "pink-100": "#fedfec",
  "pink-200": "#fdcae0",
  "pink-300": "#fca0c7",
  "pink-400": "#fa76af",
  "pink-500": "#f72c84",
  "pink-600": "#df1a6f",
  "pink-700": "#be165e",
  "pink-800": "#911148",
  "pink-900": "#640c32",
  "purple-50": "#f8efff",
  "purple-100": "#f5e7ff",
  "purple-200": "#eed8fe",
  "purple-300": "#e0b8fe",
  "purple-400": "#d299fe",
  "purple-500": "#9b37f2",
  "purple-600": "#7a12d4",
  "purple-700": "#680fb4",
  "purple-800": "#4f0c8a",
  "purple-900": "#37085f",
  "red-50": "#feeded",
  "red-100": "#fde3e3",
  "red-200": "#fcd1d1",
  "red-300": "#faacac",
  "red-400": "#f78787",
  "red-500": "#f34747",
  "red-600": "#d8273a",
  "red-700": "#b82131",
  "red-800": "#8c1926",
  "red-900": "#61121a",
  "teal-50": "#ebfafb",
  "teal-100": "#e1f8f9",
  "teal-200": "#cdf3f5",
  "teal-300": "#a5eaed",
  "teal-400": "#7de0e4",
  "teal-500": "#37d0d6",
  "teal-600": "#1e9094",
  "teal-700": "#1a7a7e",
  "teal-800": "#145e60",
  "teal-900": "#0e4143",
  "yellow-50": "#fefae8",
  "yellow-100": "#fef7dc",
  "yellow-200": "#fcf1c5",
  "yellow-300": "#fae797",
  "yellow-400": "#f8dc69",
  "yellow-500": "#f5c918",
  "yellow-600": "#e8ad11",
  "yellow-700": "#c5930e",
  "yellow-800": "#97700b",
  "yellow-900": "#684e08",
};
